import { Accordion, Badge, Box, Group, SimpleGrid, Text } from "@mantine/core";
import type { QueryItem } from "../../types/encounter-drg";
import { formatDateTime, getSourceColor, getStatusColor } from "./helpers";
import { FONT, SECTION, TW } from "./theme";

const QueriesSection = ({
  queries,
  teamLabel,
}: {
  queries: QueryItem[];
  teamLabel: string;
}) => {
  return (
    <Box>
      <Group gap={6} mb="sm">
        <Badge
          size="xs"
          styles={{
            root: {
              backgroundColor: SECTION.queryBadgeBg,
              color: SECTION.queryBadgeText,
              borderColor: SECTION.queryBadgeBorder,
              borderWidth: 1,
              borderStyle: "solid",
              fontWeight: 700,
              fontSize: 10,
              paddingLeft: 6,
              paddingRight: 6,
            },
          }}
        >
          Q
        </Badge>
        <Text
          size={`${FONT.xs}px`}
          fw={600}
          c={SECTION.queryTitle}
          td="underline"
        >
          Queries ({queries.length})
        </Text>
      </Group>

      {queries.length > 0 ? (
        <Accordion variant="separated" radius="md">
          {queries.map((query, index) => (
            <Accordion.Item key={query.id} value={query.id}>
              <Accordion.Control px="sm" py={4}>
                <Group gap="sm" wrap="nowrap" style={{ width: "100%" }}>
                  <Text size={`${FONT.sm}px`} c={TW.gray500} w={24}>
                    {index + 1}
                  </Text>
                  <Text
                    size={`${FONT.sm}px`}
                    fw={500}
                    style={{ minWidth: 70 }}
                  >
                    {query.code}
                  </Text>
                  <Text
                    size={`${FONT.sm}px`}
                    c={TW.gray700}
                    lineClamp={1}
                    style={{ flex: 1 }}
                  >
                    {query.description || "-"}
                  </Text>
                  <Group gap={4} wrap="nowrap">
                    <Badge
                      size="xs"
                      color={getSourceColor(query.source)}
                      variant="light"
                    >
                      {query.source}
                    </Badge>
                    <Badge
                      size="xs"
                      color={getStatusColor(query.status)}
                      variant="light"
                    >
                      {query.status}
                    </Badge>
                  </Group>
                </Group>
              </Accordion.Control>
              <Accordion.Panel>
                <SimpleGrid cols={2} spacing="sm">
                  <Box>
                    <Text size={`${FONT.xs}px`} c={TW.gray500}>
                      Query ID
                    </Text>
                    <Text size={`${FONT.sm}px`}>
                      {query.queryId || "N/A"}
                    </Text>
                  </Box>
                  <Box>
                    <Text size={`${FONT.xs}px`} c={TW.gray500}>
                      Updated By
                    </Text>
                    <Text size={`${FONT.sm}px`}>
                      {query.updatedBy || "N/A"}
                    </Text>
                  </Box>
                  <Box>
                    <Text size={`${FONT.xs}px`} c={TW.gray500}>
                      Created At
                    </Text>
                    <Text size={`${FONT.sm}px`}>
                      {formatDateTime(query.createdAt)}
                    </Text>
                  </Box>
                  <Box>
                    <Text size={`${FONT.xs}px`} c={TW.gray500}>
                      Source
                    </Text>
                    <Text size={`${FONT.sm}px`}>{query.source}</Text>
                  </Box>
                </SimpleGrid>
                {query.message && (
                  <Box mt="xs">
                    <Text size={`${FONT.xs}px`} c={TW.gray500}>
                      Details
                    </Text>
                    <Text size={`${FONT.sm}px`} c={TW.gray700}>
                      {query.message}
                    </Text>
                  </Box>
                )}
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      ) : (
        <Text size={`${FONT.sm}px`} c={TW.gray700} py={4}>
          No queries
        </Text>
      )}
    </Box>
  );
};

export default QueriesSection;
